import { render, staticRenderFns } from "./MandatVue.vue?vue&type=template&id=14155e10&"
import script from "./MandatVue.vue?vue&type=script&lang=js&"
export * from "./MandatVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports